import { render, staticRenderFns } from "./shareProfit-add-or-update.vue?vue&type=template&id=2d0c71be&"
import script from "./shareProfit-add-or-update.vue?vue&type=script&lang=js&"
export * from "./shareProfit-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports